import React, { useState } from 'react';
import ColorBar from './ColorBar/ColorBar';
import EffectChartDropdown from './EffectChartDropdown/EffectChartDropdown';
import {
  Cell,
  ExpandArrowCloseIcon,
  ExpandArrowOpenIcon,
  LabelText,
  Row,
} from './EffectHorizontalChart.styles';
import { IToggleState, Topic } from '../../../../../../services/reports';
import TrendBox from '../../../TrendBox/TrendBox';

interface EffectHorizontalChartProps {
  topic: Topic;
  togglersState: IToggleState;
}

const EffectHorizontalChart: React.FC<EffectHorizontalChartProps> = ({ topic, togglersState }) => {
  const { label, average_value, change, questions, description, historical_value } = topic;
  const [isDropMenuActive, setIsDropMenuActive] = useState<boolean>(false);
  const [isDropMenuMounted, setIsDropMenuMounted] = useState<boolean>(false);

  const isNegative = Number(change) < 0;

  const handleToggleDropdown = () => {
    if (!isDropMenuActive) {
      setIsDropMenuMounted(true);
    }
    setIsDropMenuActive(state => !state);
  };

  const handleDropdownExited = () => {
    setIsDropMenuMounted(false);
  };

  return (
    <>
      <Row isDropMenuActive={isDropMenuMounted} onClick={handleToggleDropdown}>
        <Cell>
          {isDropMenuActive ? (
            <ExpandArrowCloseIcon
              onClick={e => {
                e.stopPropagation();
                handleToggleDropdown();
              }}
            />
          ) : (
            <ExpandArrowOpenIcon
              onClick={e => {
                e.stopPropagation();
                handleToggleDropdown();
              }}
            />
          )}
          <LabelText>{label}</LabelText>
        </Cell>
        <Cell>{average_value.toFixed(1)}</Cell>

        {historical_value ? (
          <TrendBox change={change} isNegative={isNegative} hasBorder={true} />
        ) : (
          <td />
        )}

        <Cell>
          <ColorBar data={topic} togglersState={togglersState} />
        </Cell>
      </Row>
      {isDropMenuMounted ? (
        <EffectChartDropdown
          isOpen={isDropMenuActive}
          onExited={handleDropdownExited}
          questions={questions}
          togglersState={togglersState}
          description={description}
        />
      ) : null}
    </>
  );
};

export default EffectHorizontalChart;
